import React from 'react'
import { Typography } from 'antd'
import { isNil } from 'lodash'
import PropTypes from 'prop-types'

import { formatDate } from '../../utils'

const UpdateDataText = ({ updatedAt, updatedBy }) =>
  isNil(updatedAt) ? (
    <Typography.Text>No change performed yet</Typography.Text>
  ) : (
    <Typography.Text>
      Updated {formatDate(updatedAt)} by {updatedBy}
    </Typography.Text>
  )

UpdateDataText.propTypes = {
  updatedAt: PropTypes.string,
  updatedBy: PropTypes.string,
}

UpdateDataText.defaultProps = {
  updatedAt: undefined,
  updatedBy: undefined,
}

export default UpdateDataText
